import { UserGroup } from '@models';
import { MutationPayload } from './mutation-payload';

export interface CreateProjectCommitteesResult {
  createProjectCommittees: CreateProjectCommitteesPayload;
}

export interface CreateProjectCommitteesPayload extends MutationPayload {
  committees: UserGroup[];
}
